import { useCallback, useState } from 'react';

import { invoicesStampedPdfRetrieve } from '~/data/generated/endpoints/invoices/invoices';
import type { Invoice } from '~/data/schemas/invoice';

export const useStampedInvoice = ({ invoice }: { invoice: Invoice | null | undefined }) => {
  const [isLoading, setIsLoading] = useState(false);

  const downloadStampedInvoice = useCallback(
    async ({ includeSupportingData = false }: { includeSupportingData?: boolean } = {}) => {
      if (!invoice) {
        return;
      }

      setIsLoading(true);
      try {
        // The endpoint streams a binary PDF; the mutator returns it as a Blob
        // (AMP-503). The query param is snake_case on the generated endpoint. The
        // response type unions in the 400 (void) branch, but a non-2xx throws, so
        // narrow to Blob here.
        const { data } = await invoicesStampedPdfRetrieve(invoice.id, {
          include_supporting_data: includeSupportingData,
        });
        const blob = data as Blob;

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `${invoice.number}-stamped.pdf`;
        link.click();
        URL.revokeObjectURL(url);
      } finally {
        setIsLoading(false);
      }
    },
    [invoice],
  );

  return {
    downloadStampedInvoice,
    isLoading,
  };
};
